import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import ChartUserByCountry from '../ChartUserByCountry';
import CustomizedTreeView from '../CustomizedTreeView';
import Copyright from '../internals/components/Copyright';
import { useState, useContext } from "react"; 
import { EventContext } from "../../../pages/Dashboard";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
// App.js or index.js
import 'react-big-calendar/lib/css/react-big-calendar.css';

const Scheduler = ({ eventDocId }) => {
  const event = useContext(EventContext);
  const [guestRows, setGuestRows] = useState([]);
  const {eventDetails} = useContext(EventContext); 
  const eventCode = eventDetails?.eventCode;  
  const eventID = eventDetails?.eventId; 

  // const localizer = dayjsLocalizer(dayjs)
  const localizer = momentLocalizer(moment);
  // holidays.js
 const usaHolidays2025 = [
  {
    title: "New Year's Day",
    start: new Date(2025, 0, 1),  // January 1, 2025
    end: new Date(2025, 0, 1),
    allDay: true,
  },
  {
    title: "Martin Luther King Jr. Day",
    start: new Date(2025, 0, 20),  // January 20, 2025 (3rd Monday of January)
    end: new Date(2025, 0, 20),
    allDay: true,
  },
  {
    title: "Presidents' Day",
    start: new Date(2025, 1, 17),  // February 17, 2025 (3rd Monday of February)
    end: new Date(2025, 1, 17),
    allDay: true,
  },
  {
    title: "Memorial Day",
    start: new Date(2025, 4, 26),  // May 26, 2025 (Last Monday of May)
    end: new Date(2025, 4, 26),
    allDay: true,
  },
  {
    title: "Independence Day",
    start: new Date(2025, 6, 4),  // July 4, 2025
    end: new Date(2025, 6, 4),
    allDay: true,
  },
  {
    title: "Labor Day",
    start: new Date(2025, 8, 1),  // September 1, 2025 (1st Monday of September)
    end: new Date(2025, 8, 1),
    allDay: true,
  },
  {
    title: "Columbus Day",
    start: new Date(2025, 9, 13),  // October 13, 2025 (2nd Monday of October)
    end: new Date(2025, 9, 13),
    allDay: true,
  },
  {
    title: "Veterans Day",
    start: new Date(2025, 10, 11),  // November 11, 2025
    end: new Date(2025, 10, 11),
    allDay: true,
  },
  {
    title: "Thanksgiving Day",
    start: new Date(2025, 10, 27),  // November 27, 2025 (4th Thursday of November)
    end: new Date(2025, 10, 27),
    allDay: true,
  },
  {
    title: "Christmas Day",
    start: new Date(2025, 11, 25),  // December 25, 2025
    end: new Date(2025, 11, 25),
    allDay: true,
  }
];


  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
    
   
        
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: 9 }}>
        
        <Calendar
          localizer={localizer}
          events={usaHolidays2025}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 500 }}
        />
         
        </Grid>
        <Grid size={{ xs: 12, lg: 3 }}>
          <Stack gap={2} direction={{ xs: 'column', sm: 'row', lg: 'column' }}>
            <CustomizedTreeView />
            <ChartUserByCountry />
          </Stack>
        </Grid>
      </Grid> 

      <Copyright sx={{ my: 4 }} />
    </Box>
  );
};
export default Scheduler;